/* ============================================================
   AURMILA — Componenti: galleria scorrevole e upsell rapido
   ============================================================ */
(function () {
  'use strict';

  /* ---------- GALLERIA ---------- */
  function avviaGalleria() {
    var gal = document.querySelector('[data-gal]');
    if (!gal || gal.dataset.pronta) return;
    gal.dataset.pronta = '1';

    var pista = gal.querySelector('[data-gal-pista]');
    var slide = gal.querySelectorAll('.gal__slide');
    var mini = gal.querySelectorAll('[data-vai]');
    var punti = gal.querySelectorAll('.gal__punto');
    var prec = gal.querySelector('[data-gal-prec]');
    var succ = gal.querySelector('[data-gal-succ]');
    if (!pista || slide.length === 0) return;

    var attuale = 0;

    function segna(i) {
      attuale = i;
      var k;
      for (k = 0; k < mini.length; k++) {
        mini[k].setAttribute('aria-current', String(Number(mini[k].dataset.vai) === i));
      }
      for (k = 0; k < punti.length; k++) {
        punti[k].setAttribute('aria-current', String(k === i));
      }
      if (prec) prec.disabled = i === 0;
      if (succ) succ.disabled = i === slide.length - 1;
    }

    function vaiA(i) {
      i = Math.max(0, Math.min(slide.length - 1, i));
      pista.scrollTo({ left: slide[i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      segna(i);
    }

    // Tiene sincronizzati puntini e miniature con lo scorrimento a dito
    var inCoda = false;
    pista.addEventListener('scroll', function () {
      if (inCoda) return;
      inCoda = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(pista.scrollLeft / pista.clientWidth);
        if (i !== attuale) segna(i);
        inCoda = false;
      });
    }, { passive: true });

    gal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vai]');
      if (b) { vaiA(Number(b.dataset.vai)); return; }
      if (e.target.closest('[data-gal-prec]')) { vaiA(attuale - 1); return; }
      if (e.target.closest('[data-gal-succ]')) { vaiA(attuale + 1); return; }
    });

    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { vaiA(attuale - 1); }
      if (e.key === 'ArrowRight') { vaiA(attuale + 1); }
    });

    segna(0);
  }

  /* ---------- AGGIUNTA RAPIDA DALL'UPSELL ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-agg-rapido]');
    if (!b) return;

    e.preventDefault();
    var originale = b.textContent.trim();
    b.disabled = true;
    b.textContent = 'Attendi...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.aggRapido), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, dati: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          b.textContent = res.dati.description || 'Non disponibile';
          setTimeout(function () { b.textContent = originale; b.disabled = false; }, 2200);
          return;
        }
        b.textContent = 'Aggiunto ✓';
        return fetch(window.location.pathname + '?section_id=carrello')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var h = document.getElementById('carrello-host');
            if (h) {
              h.innerHTML = html;
              var sorgente = document.querySelector('[data-conta-sorgente]');
              var n = sorgente ? (parseInt(sorgente.textContent.trim(), 10) || 0) : 0;
              var badge = document.querySelectorAll('[data-conta]');
              for (var i = 0; i < badge.length; i++) { badge[i].textContent = n; badge[i].hidden = n === 0; }

              var cass = document.querySelector('[data-pannello="carrello"]');
              if (cass) {
                cass.dataset.aperto = 'true';
                var velo = document.querySelector('[data-velo]');
                if (velo) velo.setAttribute('data-aperto', 'true');
                document.body.style.overflow = 'hidden';
              }
            }
            setTimeout(function () { b.textContent = originale; b.disabled = false; }, 900);
          });
      })
      .catch(function () { b.textContent = originale; b.disabled = false; });
  });

  /* ---------- Avvio ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avviaGalleria);
  } else {
    avviaGalleria();
  }
  document.addEventListener('shopify:section:load', function () {
    var g = document.querySelector('[data-gal]');
    if (g) g.dataset.pronta = '';
    avviaGalleria();
  });
})();
